/**
 * Safe token estimation – garanterar alltid ett nummer.
 * Returnerar 0 om estimation misslyckas.
 */
export function safeEstimateTokens(payload: any): number {
  try {
    if (!payload) return 0;

    // Om payload är string → räkna grovt antal tokens
    if (typeof payload === "string") {
      // Enkel heuristik: 1 token ≈ 4 tecken
      return Math.ceil(payload.length / 4);
    }

    // Om payload är objekt → JSON-stringify och räkna
    const str = JSON.stringify(payload);
    return Math.ceil(str.length / 4);
  } catch (err) {
    console.warn("safeEstimateTokens error:", err);
    return 0;
  }
}

/**
 * Enhanced token estimation with margin for safety
 */
export function safeEstimateTokensWithMargin(payload: any, margin: number = 1.2): number {
  const baseTokens = safeEstimateTokens(payload);
  return Math.ceil(baseTokens * margin);
}

/**
 * Token-budgeterad batch-skapare
 * Skapar batchar som inte överskrider maxTokens per batch
 */
export function makeBatches(items: any[], maxTokens: number, estPerItem: number = 600): any[][] {
  const out: any[][] = [];
  let cur: any[] = [];
  let curT = 0;
  
  for (const it of items) {
    // Add a safety margin (~20%) to reduce risk of hitting provider TPM
    let t = safeEstimateTokensWithMargin(it, 1.2);
    if (!t) t = Math.ceil(estPerItem * 1.2);
    if (cur.length && curT + t > maxTokens) {
      out.push(cur);
      cur = [];
      curT = 0;
    }
    cur.push(it);
    curT += t;
  }
  
  if (cur.length) out.push(cur);
  return out;
}